export default __webpack_public_path__ + "static/media/dealer.57fb01de.svg";